import axios from "axios";


const adminApi = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
});


adminApi.interceptors.request.use(
  (config) => {

    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },

  (error) => {
    return Promise.reject(error);
  }
);


export default adminApi;